import React, { useState } from "react";
import Modal from "react-modal";
import "../Style/_legal.scss";

// =======================================================
// Informations légales - À COMPLÉTER avant la mise en ligne
// =======================================================
const LEGAL = {
  name: "Florence Hand",
  status: "Entrepreneur individuel (micro-entreprise)",
  siret: "[À COMPLÉTER : numéro SIRET]",
  address: "5 Rue Delaugère et Clayette, 45000 Orléans",
  phone: "06 74 44 02 89",
  phoneLink: "tel:+33674440289",
  email: "florence.hand@gmail.com",
  host: {
    name: "Hostinger International Ltd",
    address: "61 Lordou Vironos Street, 6023 Larnaca, Chypre",
    website: "https://www.hostinger.fr",
  },
  lastUpdate: "octobre 2026",
};

// =======================================================
// Legal as Javascript function
// =======================================================
function Legal() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((prevIsModalOpen) => !prevIsModalOpen);
  };

  return (
    <footer className="legal-footer">
      <p>
        © {new Date().getFullYear()} {LEGAL.name} -{" "}
        <button type="button" className="legal-link" onClick={toggleModal}>
          Mentions légales et confidentialité
        </button>
      </p>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        contentLabel="Mentions légales et politique de confidentialité"
        className="Modal legal-modal"
        overlayClassName="Overlay"
      >
        <button onClick={toggleModal} className="close-button" aria-label="Fermer">
          X
        </button>

        <div className="legal-content">
          <h3>Mentions légales</h3>

          <h4>Éditeur du site</h4>
          <p>
            {LEGAL.name}
            <br />
            {LEGAL.status}
            <br />
            SIRET : {LEGAL.siret}
            <br />
            {LEGAL.address}
            <br />
            Téléphone : <a href={LEGAL.phoneLink}>{LEGAL.phone}</a>
            <br />
            Mail : <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>
          </p>
          <p>Directrice de la publication : {LEGAL.name}</p>

          <h4>Hébergement</h4>
          <p>
            {LEGAL.host.name}
            <br />
            {LEGAL.host.address}
            <br />
            <a href={LEGAL.host.website} target="_blank" rel="noopener noreferrer">
              {LEGAL.host.website}
            </a>
          </p>

          <h4>Propriété intellectuelle</h4>
          <p>
            L'ensemble des contenus de ce site (textes, images, logo) est la propriété de {LEGAL.name}, sauf mention contraire. Toute reproduction, même
            partielle, est interdite sans autorisation préalable.
          </p>

          <h4>Avertissement</h4>
          <p>
            Les prestations présentées sur ce site (réflexologie plantaire, soins énergétiques, magnétisme, coupeur de feu) relèvent du bien-être et de la
            relaxation. Elles ne constituent pas un acte médical et ne remplacent ni un diagnostic, ni un traitement prescrit par un professionnel de santé.
          </p>

          <h3>Politique de confidentialité</h3>

          <h4>Responsable du traitement</h4>
          <p>
            {LEGAL.name}, joignable à l'adresse <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>.
          </p>

          <h4>Données collectées et utilisation</h4>
          <p>
            <strong>Avis :</strong> lorsque vous laissez un avis, sont enregistrés le nom que vous indiquez, le texte de votre avis et la date d'envoi. Ces
            informations sont publiées sur ce site après validation. Votre adresse IP est également enregistrée afin de limiter les envois abusifs ; elle
            est effacée automatiquement après 30 jours.
          </p>
          <p>
            <strong>Prise de rendez-vous :</strong> les informations transmises par téléphone ou par mail servent uniquement à organiser vos séances et ne
            sont jamais cédées à des tiers.
          </p>
          <p>
            Base légale : votre consentement pour la publication de votre avis, et l'intérêt légitime de l'éditeur pour la protection du site contre le
            spam.
          </p>

          <h4>Durée de conservation</h4>
          <p>Les avis sont conservés tant qu'ils sont publiés sur le site, ou jusqu'à ce que vous en demandiez la suppression.</p>

          <h4>Services tiers</h4>
          <p>
            Le formulaire d'avis est protégé par le service reCAPTCHA de Google, qui peut collecter des données techniques (adresse IP, informations sur
            le navigateur) et déposer des cookies afin de distinguer les humains des robots. Ce service n'est chargé qu'à l'ouverture du formulaire. Les
            polices de caractères sont fournies par Google Fonts, ce qui transmet votre adresse IP aux serveurs de Google. Ces données peuvent être
            transférées hors de l'Union européenne. Pour en savoir plus, consultez la{" "}
            <a href="https://policies.google.com/privacy?hl=fr" target="_blank" rel="noopener noreferrer">
              politique de confidentialité de Google
            </a>
            .
          </p>
          <p>Ce site n'utilise aucun outil de mesure d'audience et ne dépose lui-même aucun cookie.</p>

          <h4>Vos droits</h4>
          <p>
            Conformément au Règlement général sur la protection des données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit
            d'accès, de rectification, d'effacement, d'opposition et de limitation du traitement de vos données. Pour exercer ces droits, notamment pour
            faire retirer un avis, écrivez à <a href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>.
          </p>
          <p>
            Vous pouvez également introduire une réclamation auprès de la CNIL (
            <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">
              www.cnil.fr
            </a>
            ).
          </p>

          <p className="legal-update">Dernière mise à jour : {LEGAL.lastUpdate}</p>
        </div>
      </Modal>
    </footer>
  );
}

export default Legal;
